module.exports = __webpack_public_path__ + "img/bottom2.2daba202.jpg";